export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const REMOVE_NOTIFICATION_BY_UID = 'REMOVE_NOTIFICATION_BY_UID';

export default {
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  REMOVE_NOTIFICATION_BY_UID,
};
